var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9999 9.68412C13.9999 11.3592 13.3681 12.9657 12.2435 14.1501C11.1189 15.3346 9.59353 16 8.00306 16C6.41258 16 4.88725 15.3346 3.76262 14.1501C2.63798 12.9657 2.00617 11.3592 2.00617 9.68412C1.96866 8.84698 2.10247 8.01114 2.39852 7.23323C2.69458 6.45532 3.14596 5.75353 3.72208 5.17543C3.96195 4.92701 4.22502 4.67774 4.50167 4.41753C5.63389 3.3632 6.80368 2.2735 6.80368 0.420841C6.80372 0.344678 6.82337 0.269952 6.86054 0.204622C6.89771 0.139291 6.95101 0.0858031 7.01477 0.0498541C7.07852 0.0139052 7.15034 -0.00315824 7.22257 0.000481048C7.29481 0.00412034 7.36475 0.0283262 7.42496 0.0705204C8.7103 1.03159 9.63598 2.43588 10.0417 4.04014C10.4473 5.64441 10.3074 7.34758 9.6462 8.85464C10.3113 8.48252 10.8582 7.91302 11.219 7.21672C11.4777 6.67652 11.6088 6.07853 11.6012 5.47354C11.6012 5.39002 11.6248 5.30839 11.669 5.23903C11.7132 5.16968 11.7759 5.11572 11.8493 5.08404C11.9227 5.05235 12.0033 5.04436 12.081 5.06109C12.1587 5.07781 12.2299 5.11849 12.2856 5.17796C13.3921 6.38782 14.0071 8.00434 13.9999 9.68412Z",
    fill: "#F66262"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopular);
export default __webpack_public_path__ + "static/media/popular.73c6cde8afb65567aef0208cbc244a7f.svg";
export { ForwardRef as ReactComponent };